import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import {
  LayoutDashboard, ArrowLeftRight, Package, ClipboardCheck, Boxes,
} from "lucide-react";
import { useScenario } from "../../store";
import { LegacyAppShell } from "./LegacyAppShell";
import { apiMode } from "@/services";
import { api } from "@/services/http/client";

const RAIL_ITEMS = [
  { id: "dashboard", icon: LayoutDashboard, label: "Overview", path: "/warehouse" },
  { id: "hub", icon: Boxes, label: "WMS Hub", path: "/warehouse/hub" },
  { id: "pick", icon: Package, label: "Pick&Pack", path: "/warehouse/pick-pack" },
  { id: "transfers", icon: ArrowLeftRight, label: "Transfers", path: "/warehouse/transfers" },
  { id: "count", icon: ClipboardCheck, label: "Count", path: "/warehouse/count" },
];

const TABS: Record<string, { label: string; path: string; end?: boolean }[]> = {
  dashboard: [{ label: "Warehouse Overview", path: "/warehouse", end: true }],
  hub: [{ label: "WMS Hub & Execution", path: "/warehouse/hub" }],
  pick: [{ label: "Pick & Pack", path: "/warehouse/pick-pack" }],
  transfers: [{ label: "Stock Transfers", path: "/warehouse/transfers" }],
  count: [{ label: "Stock Count", path: "/warehouse/count" }],
};

function getActiveSection(pathname: string) {
  if (pathname === "/warehouse" || pathname === "/warehouse/") return "dashboard";
  if (pathname.startsWith("/warehouse/hub")) return "hub";
  if (pathname.startsWith("/warehouse/pick")) return "pick";
  if (pathname.startsWith("/warehouse/transfer")) return "transfers";
  if (pathname.startsWith("/warehouse/count")) return "count";
  return "dashboard";
}

export function WarehouseLayout() {
  const location = useLocation();
  const scenario = useScenario();
  const activeSection = getActiveSection(location.pathname);
  const [live, setLive] = useState<{ name: string; subtitle: string } | null>(null);
  useEffect(() => {
    if (!apiMode) return;
    api<{ warehouse: { name: string }; user: { name: string } }>("/api/warehouse/me")
      .then((m) => setLive({ name: m.user.name, subtitle: m.warehouse.name }))
      .catch(() => setLive({ name: "Warehouse", subtitle: "" }));
  }, []);
  const identity = apiMode
    ? (live ?? { name: "…", subtitle: "" })
    : { name: scenario.userName, subtitle: "Main DC" };

  return (
    <LegacyAppShell
      brand="WH"
      surface="Warehouse"
      homePath="/warehouse"
      items={RAIL_ITEMS}
      activeId={activeSection}
      tabs={TABS[activeSection]}
      identity={identity}
    >
      <Outlet />
    </LegacyAppShell>
  );
}
